import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { format, eachDayOfInterval, parseISO } from 'date-fns';
import TimeFilterDropdown from '../timeFilterSelect/TimeFilterDropdown';
import DashboardFilters from 'components/specific/DashboardFilters';
import CardFilters from 'components/specific/CardFilters';
import { AppIcon } from '@common';
import { crossIcon } from '@src/assets/svg';

const VisitsChart = ({
  totalVisit,
  totalVisitCount,
  setVisit,
  state,
  dispatch,
  date,
}) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 shadow-md rounded-md border border-gray-200">
          <p className="text-sm font-semibold">
            Visit: {payload[0].payload.day}
          </p>
          <p className="text-sm">Date: {payload[0].payload.visit}</p>
        </div>
      );
    }
    return null;
  };
  console.log('totalVisit', totalVisit);
  const dailyVisits = {};

  const [filters, setFilters] = React.useState({});

  totalVisit?.length > 0 &&
    totalVisit?.forEach(({ start_date, end_date, visits }) => {
      const days = eachDayOfInterval({
        start: parseISO(start_date),
        end: parseISO(end_date),
      });

      // Distribute visits equally across the date range
      const visitsPerDay = visits / days.length;

      days.forEach((day) => {
        const dateStr = format(day, 'yyyy-MM-dd');
        dailyVisits[dateStr] = (dailyVisits[dateStr] || 0) + visitsPerDay;
      });
    });

  const weekDaysCount = { M: 0, T: 0, W: 0, Th: 0, F: 0, S: 0, Su: 0 };

  Object.keys(dailyVisits).forEach((dateStr) => {
    const date = parseISO(dateStr);
    const weekday = format(date, 'EEE')[0]; // Get first letter of weekday

    if (weekday === 'T' && format(date, 'EEEE') === 'Thursday') {
      weekDaysCount['Th'] += dailyVisits[dateStr];
    } else {
      weekDaysCount[weekday] += dailyVisits[dateStr];
    }
  });

  const data2 =
    totalVisit?.length > 0 &&
    totalVisit?.map((day) => ({
      day: day.visits,
      visits: day.visits,
      visit: `${new Date(day.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit' })} - ${new Date(day.end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit' })}, ${new Date(day.start_date).getFullYear()}`,
    }));

  return (
    <div className="bg-white shadow-md rounded-[20px] min-h-[464px] h-[100%] p-4">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Total Numbers of Visits</h2>
        <CardFilters id="filters-2" setFilters={setFilters} />
      </div>
      {Object.entries(state[1]?.selectedList).length > 0 ? (
        <span className="ml-6 !bg-gray-200 text-grey-600   px-0.5	">
          <span className="dashboardFilters--showcase--selectedFilters--item--value">
            {state[1].title === 'Date'
              ? Object.values(state[1].selectedList || {}).join(',')
              : Object.keys(state[1].selectedList || {}).join(',')}
          </span>
          <AppIcon
            icon={crossIcon}
            onClick={() => {
              if (state[1].title === 'Date') {
                date.removeDate();
              }
            }}
            className="dashboardFilters--showcase--selectedFilters--item--icon"
          />
        </span>
      ) : (
        console.log('state-have is empty', state[1])
      )}
      <div className="flex justify-between items-center border-t border-b h-[110px]">
        <p className="text-[55px] leading-[24px] font-medium ">
          {totalVisitCount}{' '}
          <span className="text-gray-500 text-lg">Visits</span>
        </p>
        {/*<p className="text-red-500 text-sm">23% ⬤ last Week</p>*/}
      </div>

      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={data2}
          margin={{ top: 10, right: 20, left: 10, bottom: 10 }}
        >
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <CartesianGrid strokeDasharray="3 3" />
          <Bar
            dataKey="visits"
            fill="#C2D6FF"
            activeBar={{ fill: '#375DFB', opacity: 0.7 }}
          ></Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default VisitsChart;
